export default {
  selectedStatus: [],
  selectedYear: '',
  selectedSeason: [],
  selectedVariety: '',
  selectedGrade: '',
  selectedExcludedArea: 0,
  word: '',
  currentPage: 1,
  orderNum: 0,
  sort: 'asc',
  modalOrderNum: 0,
  modalSort: 'asc',
  fileName: ''
}
